import { FC } from 'react'
import { AcquisitionsOverviewMap } from 'src/v2/views/owner-reveal/insights/acquisition-history/acquisitions-overview/map'
import { AcquisitionsOverviewTable } from 'src/v2/views/owner-reveal/insights/acquisition-history/acquisitions-overview/table'

export const AcquisitionsOverviewContent: FC = () => {
  return (
    <>
      <AcquisitionsOverviewMap />
      <AcquisitionsOverviewTable />
    </>
  )
}
